<template>
    <layout :title="$attrs.title" :required="$attrs.required">
        <div class="custom-select-container flex flex-row flex-row-aic">
            <div class="left" @click="$emit('click')">
                <div v-if="value" class="value">{{ value }}</div>
                <div v-else class="default">{{ placeholder }}</div>
            </div>
            <div class="right" v-if="hideRemove ? false : true">
                <van-icon v-if="value" :size="20" color="#A2A3A4" name="clear" @click="$emit('clear')" />
                <van-icon color="#A2A3A4" :size="20" name="arrow" @click="$emit('click')" />
            </div>
        </div>
    </layout>
</template>

<script>
/**
 * @description 当前组件只为展示UI和数据。
 */
import Layout from './Layout.vue';
export default {
    name: 'CSelectImitate',

    components: {
        Layout
    },

    props: {
        value: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: '请选择'
        },
        hideRemove: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="less" scoped>
.custom-select {
    &-container {
        justify-content: space-between;

        .left {
            flex: 1;

            .value {
                font-size: 14px;
                font-weight: 400;
                color: #1A1A1F;
                line-height: 20px;
            }

            .default {
                font-size: 14px;
                font-weight: 400;
                color: #727273;
                line-height: 20px;
            }
        }

        .right {
            .van-icon {
                margin-left: 2px;
            }
        }
    }
}
</style>